// extracted by mini-css-extract-plugin
module.exports = {"container":"Divider_container__2wzz6","white":"Divider_white__1iGRh","black":"Divider_black__1v7S7"};